import { makeStyles } from "@material-ui/core";
import { TopNavBar } from "../../components";
import React from "react";
import { QueueScenarios } from "./queueScenario";
import axios from "axios";
import { AlertProps } from "../../utils";
import { AlertContext } from "../../contexts";

const useStyles = makeStyles((theme) => ({
  root: {
    height: "100%",
  },
}));

export const QueueItems = (props) => {
  const { queue, selectedQueue } = props;
  const classes = useStyles();
  const alertMessage = React.useContext(AlertContext);

  const [state, setState] = React.useState("");
  const [scenarios, setScenarios] = React.useState([]);

  const [currantScenario, setcurrantScenario] = React.useState("");

  const [queryData, setQueryData] = React.useState({});
  const [refresh , setRefresh]  = React.useState(false);

  React.useEffect(() => {
    const data = selectedQueue;
    const getQueueName = selectedQueue.queuename;

    if (Object.keys(data).length > 0) {
      setState(getQueueName);
      setQueryData({ queueid: data?.queueid, queue_id: data?._id });
      getScenariosData(data?._id);
    } else {
      if (queue) {
        setState(queue?.queuename);
        getScenariosData(queue?._id);
        setQueryData({ queueid: queue?.queueid, queue_id: queue?._id });
      }
    }
    // eslint-disable-next-line
  }, [queue, selectedQueue]);

  React.useEffect(() => {
    props?.getdata()
    const data = selectedQueue;
    const getQueueName = selectedQueue.queuename;

    if (Object.keys(data).length > 0) {
      setState(getQueueName);
      setQueryData({ queueid: data?.queueid, queue_id: data?._id });
      getScenariosData(data?._id);
    } else {
      if (queue) {
        setState(queue?.queuename);
        getScenariosData(queue?._id);
        setQueryData({ queueid: queue?.queueid, queue_id: queue?._id });
      }
    }
    // eslint-disable-next-line
  }, [refresh]);

  const setQueue = () => {
    setRefresh(!refresh)
  }
  const db = sessionStorage.getItem("ProjectDbname");
  const getScenariosData = async (queueid) => {
    try {
      let params = {
        db_name: `${db}`,
        entity: "queuescenarios",
        filter: `queuescenarios.queueid=='${queueid}'&&queuescenarios.active==true && queuescenarios.activestatus==true`,
        sort: "queuescenarios.scenarioname ASC",
        return_fields: "queuescenarios",
      };
      let config = {
        method: "post",
        url: `${process.env.REACT_APP_ARANGO_URL_READ}`,
        headers: {
          "Content-Type": "application/json",
        },
        data: params,
      };

      await axios(config)
        .then((res) => {
          if (res.data.Code === 201) {
            let data = res.data.result;
            data = data?.filter(
              (e) =>
                props.PermissionData?.filter(
                  (v) =>
                    v.scenarioChildren?.filter(
                      (b) =>
                        b.repoid.unique_id === e._id && b.permsnread === true
                    ).length !== 0
                ).length !== 0
            );
            setScenarios(data);
            setcurrantScenario(data[data.length - 1]?._id);
          } else {
            alertMessage?.setSnack({
              ...alertMessage,
              open: true,
              severity: AlertProps.severity.error,
              msg: "Something Went Wrong",
              vertical: AlertProps.vertical.top,
              horizontal: AlertProps.horizontal.center,
            });
          }
        })
        .catch((err) => {
          alertMessage?.setSnack({
            ...alertMessage,
            open: true,
            severity: AlertProps.severity.error,
            msg: "Something Went Wrong",
            vertical: AlertProps.vertical.top,
            horizontal: AlertProps.horizontal.center,
          });
        });
    } catch (error) {}
  };

  const updateScenaorio = (value) => {
    setcurrantScenario(value);
  };

  return (
    <React.Fragment>
      <TopNavBar
        PermissionData={props.PermissionData}
        QueueName={state}
        Scenarios={scenarios}
        defaultScenarios={currantScenario}
        updateScenaorio={updateScenaorio}
        refresh={refresh}
      />
      <div style={{ height: "calc(100% - 64px)" }}>
        <div className={classes.root}>
          <QueueScenarios
            PermissionData={props.PermissionData}
            queueId={queryData?.queue_id}
            currantScenario={currantScenario}
            updateScenaorio={updateScenaorio}
            setQueue={setQueue}
            refresh={refresh}
          />
        </div>
      </div>
    </React.Fragment>
  );
};
